'use es6';

import * as ReactRedux from 'react-redux';
import SalesContentIndexUIReduxContext from 'SalesContentIndexUI/data/redux/SalesContentIndexUIReduxContext';
const emptyFunction = () => ({});
export default ((mapStateToProps, mapDispatchToProps) => {
  mapStateToProps = mapStateToProps || emptyFunction;
  return ReactRedux.connect(mapStateToProps, mapDispatchToProps, null, {
    context: SalesContentIndexUIReduxContext
  });
});